import React, { useEffect, useState } from "react";
import organizatonLogo from "../../images/icon/organization.png";
import UserProfile from "../../../src/assets/img/profile-icon.svg";
import { useParams } from "react-router-dom";
import DataTable from "../../components/Comman/CustomTable/CommonTable";
import { EyeOutlined } from "@ant-design/icons";
import { Avatar, Space, Tag } from "antd";
import SideDrawer from "../../components/Comman/Drawer/SideDrawer";
import { useDispatch, useSelector } from "react-redux";
import {
  changeOrgLeaderController,
  getElementsOrganizationById,
  getOrganizationById,
} from "../../actions/admin";
import { Loader } from "lucide-react";
import {
  capitalizeFirstLetter,
  formatMobileNumber,
  formatToCST,
} from "../../utils/comman";
import { getOrgLeaderOrganizationAction } from "../../actions/leader";
import { getUserOrganizationById } from "../../actions/user";
import ChangeRoleModel from "../../components/Comman/ChangeRoleModel/ChangeRoleModel";

const ViewOrganization = () => {
  const location = useParams();
  const dispatch = useDispatch<any>();
  const loading = useSelector((state: any) => state?.General?.isLoading);
  const user = useSelector((state: any) => state?.Auth?.user);
  const handleRefresh = useSelector(
    (state: any) => state?.General?.updateListing
  );
  const roleId = user?.user?.roleId;
  const organizationId = location.id;
  // const [loading, setLoading] = useState<boolean>(true);
  const [openRoleModel, setOpenRoleModel] = useState<boolean>(false);
  const [modelRoleId, setModelRoleId] = useState<number>(null);
  const [userId, setUserId] = useState<number>(null);
  const [iconLoading, setIconLoading] = useState<boolean>(true);
  const [organization, setOrganization] = useState<any>();
  const [elementsAssigned, setElementsAssigned] = useState<any>();
  const [openUserModel, setOpenUserModel] = useState<boolean>(false);
  const [reflectRole, setReflectRole] = useState<boolean>(false);
  const [isOrganizationModalOpen, setIsOrganizationModalOpen] =
    useState<boolean>(false);
  const [sortConfig, setSortConfig] = useState<{
    field: string | null;
    order: "asc" | "desc" | null;
  }>({
    field: null,
    order: null,
  });
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const getOrganizationData = async () => {
    const callback = (resp: any) => {
      if (resp?.status === 200) {
        setOrganization(resp?.data || []);
      }
    };

    if (roleId === 1) {
      dispatch(getOrganizationById(organizationId, callback)); // ✅ Pass both arguments
    } else if ([2, 3].includes(roleId)) {
      await dispatch(getOrgLeaderOrganizationAction(organizationId, callback)); // ✅ organizationId was missing
    } else {
      await dispatch(getUserOrganizationById(organizationId, callback)); // ✅ Pass both arguments
    }
  };

  useEffect(() => {
    getOrganizationData();
  }, [reflectRole, handleRefresh]);

  const getElementsAssigned = (params = {}) => {
    // setLoading(true);
    const data = {
      params,
      organizationId,
      roleId,
    };
    dispatch(
      getElementsOrganizationById(data, (resp: any) => {
        // setLoading(false);
        if (resp?.status === 200 || resp?.status === 201) {
          setElementsAssigned(resp?.data || []);
          setPagination({
            ...pagination,
            total: resp.pagination?.totalItems,
            current: resp.pagination?.currentPage,
            pageSize: resp.pagination?.pageSize,
          });
        }
      })
    );
  };

  useEffect(() => {
    getElementsAssigned({
      page: pagination.current || 1,
      limit: pagination.pageSize || 10,
    });
  }, []);

  const handleIsOrganizationModelOpen: any = () => {
    setIsOrganizationModalOpen(!isOrganizationModalOpen);
  };

  const handleTableChange = (pagination: any, filters: any, sorter: any) => {
    let newSortConfig = { ...sortConfig };
    if (sorter && Object.keys(sorter).length > 0) {
      newSortConfig = {
        field: sorter.field,
        order: sorter.order === "ascend" ? "asc" : "desc",
      };
    }
    setSortConfig(newSortConfig);
    getElementsAssigned({
      page: pagination.current || 1,
      limit: pagination.pageSize || 10,
      ...(newSortConfig.field && newSortConfig.order
        ? {
            sort: newSortConfig.field,
            order: newSortConfig.order,
          }
        : {}),
    });
  };

  const handleEditOrganization = () => {
    handleIsOrganizationModelOpen();
  };

  const handleCreateUserModel = () => {
    setOpenUserModel(!openUserModel);
  };

  const handelRoleModel = (roleId) => {
    setOpenRoleModel(!openRoleModel);
    setModelRoleId(roleId);
  };

  const handleModelFunction = () => {
    dispatch(
      changeOrgLeaderController(
        {
          roleId: modelRoleId,
          User_ID: userId,
          organizationId: organizationId,
        }, // Ensure correct param names
        (resp: any) => {
          if (resp?.status === 200 || resp?.status === 201) {
            setOpenRoleModel(!openRoleModel);
            setReflectRole(!reflectRole);
          }
        }
      )
    );
  };

  const columns = [
    {
      title: "Category Code",
      dataIndex: "categoryId",
      key: "categoryId",
      sorter: true,
      render: (_: any, record: any) => record?.category?.name || "-",
    },
    {
      title: "Element Name",
      dataIndex: "DataElements_Name",
      key: "DataElements_Name",
      sorter: true,
    },
    {
      title: "Description",
      dataIndex: "DataElements_Description",
      key: "DataElements_Description",
    },
    {
      title: "Budget",
      dataIndex: "DataElements_IsBudgeted",
      key: "DataElements_IsBudgeted",
      render: (text: any) => {
        const isBudgeted = text === true; // Assuming "Yes" means it's budgeted
        return (
          <Tag
            color={isBudgeted ? "green" : "red"}
            style={{ color: "white", fontWeight: "bold" }}
          >
            {isBudgeted ? "Yes" : "No"}
          </Tag>
        );
      },
    },

    {
      title: "Element Type",
      dataIndex: "DataElements_DataType",
      key: "DataElements_DataType",
      render: (text: any) => capitalizeFirstLetter(text),
    },
    {
      title: "Updated On",
      dataIndex: "DataElements_LastUpdated",
      key: "DataElements_LastUpdated",
      render: (value) => formatToCST(value) || "-",
    },
    {
      title: "Updated By",
      dataIndex: "DataElements_LastUpdatedBy",
      key: "DataElements_LastUpdatedBy",
    },
    {
      title: "Action",
      key: "action",
      render: () => (
        <Space size="middle">
          {/* <span
            style={{ color: "#3DA57F", fontWeight: "bold", fontSize: "16px" }}
          >
            <EditOutlined />
          </span> */}
          <span
            style={{ color: "#3DA57F", fontWeight: "bold", fontSize: "16px" }}
          >
            <EyeOutlined />
          </span>
          {/* <span
            style={{ color: "#3DA57F", fontWeight: "bold", fontSize: "16px" }}
          >
            <DeleteOutlined />
          </span> */}
        </Space>
      ),
    },
  ];

  return (
    <div>
      {/* <Header /> */}
      <div className="flex gap-[20px] mt-[20px] flex-wrap">
        <div className="lg:w-[calc(50%-10px)] w-full">
          <div className="flex brand-details-wrapper p-[10px] gap-[15px] items-center 2xl:gap-[30px] rounded-[10px] bg-primary h-full transition duration-600 hover:scale-105 flex-col sm:flex-row justify-center sm:justify-start">
            <>
              {organization?.logo ? (
                <div className="relative">
                  <img
                    src={organization?.logo}
                    alt="logo"
                    className={`px-[12px] py-[56px] bg-[#000] rounded-[10px] img-custom-fluid ${
                      iconLoading ? "invisible" : "visible"
                    }`}
                    onLoad={() => setIconLoading(false)}
                    onError={() => setIconLoading(false)}
                  />
                  {iconLoading && (
                    <div className="absolute top-1/2 left-1/2 inner-loader-col">
                      {" "}
                      <Loader width={"40px"} className="flex justify-center" />
                    </div>
                  )}
                </div>
              ) : (
                <div className="relative">
                  <img
                    src={organizatonLogo}
                    alt="logo"
                    className={`px-[12px] py-[56px] bg-[#000] rounded-[10px] img-custom-fluid`}
                  />
                </div>
              )}
            </>
            <div className="text-center sm:text-start">
              <h3 className="mb-[10px]">{organization?.name}</h3>

              <p className="info-col min-w-[65px]">
                Division of -{" "}
                {organization?.parentOrganization?.shortCode
                  ? organization?.parentOrganization?.shortCode
                  : organization?.parentOrganization?.name}
              </p>
              {organization?.addr1 && (
                <div className="d-flex gap-1 my-[10px] text-[12px] 2xl:text-[sm] justify-center sm:justify-start">
                  <p className="info-col min-w-[65px]">Address - </p>
                  <p>{organization?.addr1}</p>
                </div>
              )}
              {organization?.phone && (
                <div className="d-flex gap-1 my-[10px] text-[12px] 2xl:text-[sm] justify-center sm:justify-start">
                  <p className="info-col min-w-[65px]">Phone - </p>
                  <p>{formatMobileNumber(organization?.phone)}</p>
                </div>
              )}
              {organization?.website && (
                <div className="d-flex gap-1 my-[10px] text-[12px] 2xl:text-[sm] justify-center sm:justify-start">
                  <p className="info-col">Website - </p>
                  <a
                    href={
                      organization?.website?.startsWith("http")
                        ? organization.website
                        : `https://${organization?.website}`
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#037ECA] italic text-[14px]"
                  >
                    {organization?.website}
                  </a>
                </div>
              )}
              {[1].includes(roleId) && (
                <a
                  href="#"
                  className="text-[#48BA89] text-sm"
                  onClick={(e) => {
                    e.preventDefault(); // Prevent default anchor behavior
                    handleEditOrganization();
                  }}
                >
                  Edit Organization
                </a>
              )}
            </div>
          </div>
        </div>

        <div className="lg:w-[calc(50%-10px)] w-full">
          <div className=" brand-details-wrapper p-[22px] gap-[15px] items-center 2xl:gap-[30px] rounded-[10px] bg-primary h-full ">
            <div className="flex justify-between">
              <p className="info-col pb-[10px]">
                Primary Contact Details of the Organization{" "}
              </p>
              <p className="info-col pb-[10px]">
                Date Users:{" "}
                {organization?.organizationAssignment[0]?.dataUserCount
                  ? organization?.organizationAssignment[0]?.dataUserCount
                  : "0"}
              </p>
            </div>

            <div className="flex border-t border-[#292929] flex-col sm:flex-row items-center">
              {organization?.organizationAssignment
                ?.slice() // clone to avoid mutating original data
                ?.sort((a, b) => {
                  const roleOrder = { Leader: 1, Controller: 2 }; // lower value = higher priority
                  return roleOrder[a?.user?.role] - roleOrder[b?.user?.role];
                })
                ?.map((assignment: any) => (
                  <div
                    key={assignment.User_ID}
                    className="w-full sm:w-1/2 sm:border-r sm:border-[#292929]"
                  >
                    <div className="user-profile-col-wrapper rounded-[10px] px-[16px] 2xl:px-[20px] py-[24px] mb-[20px]">
                      <div className="flex gap-[14px]">
                        <div className="inline-flex p-1 border border-dashed border-[#A2A2A2] bg-dark rounded-full size-[54px] relative">
                          <div className="inline-flex items-center justify-center p-2 bg-[#D9D9D9] size-[45px] min-w-[45px] rounded-full ">
                            <Avatar
                              // src={assignment?.user?.profilePhoto || undefined}
                              src={UserProfile}
                              // icon={
                              //   !assignment?.user?.profilePhoto ? (
                              //     <img src={UserProfile} alt="User Profile" />
                              //   ) : undefined
                              // }
                              className="p-[3px] bg-primary rounded-[10px] object-cover"
                            />
                          </div>
                        </div>

                        <div>
                          <h4 className="text-sm 2xl:text-[16px]">
                            {assignment?.user?.name}
                          </h4>
                          <p className="text-sm 2xl:text-[14px]">
                            ({assignment?.user?.role})
                          </p>
                          <span className="user-email-col text-white break-all text-[12px] 2xl:text-[14px]">
                            {assignment?.user?.email}
                          </span>
                          <p className="text-sm 2xl:text-[14px]">
                            {formatMobileNumber(assignment?.user?.mobileNumber)}
                          </p>
                        </div>
                      </div>
                    </div>

                    {roleId === 1 && (
                      <div className="flex justify-between">
                        <button
                          className="update-role-btn"
                          onClick={() =>
                            handelRoleModel(
                              assignment?.user?.role === "Leader" ? 2 : 3
                            )
                          }
                        >
                          Update{" "}
                          {assignment?.user?.role === "Leader"
                            ? "Leader"
                            : "Controller"}
                        </button>
                      </div>
                    )}
                  </div>
                ))}

              {/* Check if a "Controller" role exists */}
              {roleId === 1 &&
                !organization?.organizationAssignment?.some(
                  (assignment: any) => assignment.user.role === "Controller"
                ) && (
                  <div className="w-full sm:w-1/2 sm:border-r sm:border-[#292929] flex items-center justify-center">
                    <button
                      // href=""
                      className="text-[#48BA89] text-sm"
                      onClick={handleCreateUserModel}
                    >
                      Add Organization Controller
                    </button>
                  </div>
                )}
            </div>
          </div>
        </div>
      </div>

      <div className="table-col mt-6 rounded-[12px] bg-[#10151A]">
        <h3 className="text-[12px] 2xl:text-sm text-[#919191] px-[20px] py-[15px]">
          Element Assignments for this Organization
        </h3>
        <DataTable
          columns={columns}
          data={elementsAssigned}
          loading={loading}
          rowKey="id"
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: pagination.total,
          }}
          onTableChange={handleTableChange}
        />
      </div>

      <SideDrawer
        open={isOrganizationModalOpen}
        onClose={handleIsOrganizationModelOpen}
        type={"organization"}
        organizationData={organization} // Pass only selected record
      />
      {openUserModel && (
        <SideDrawer
          open={openUserModel}
          onClose={handleCreateUserModel}
          type={"user"}
        />
      )}
      {openRoleModel && (
        <ChangeRoleModel
          handleConfirmRoleModel={() => handelRoleModel(roleId)}
          roleId={modelRoleId}
          handleModelFunction={handleModelFunction}
          setUserId={setUserId}
        />
      )}
    </div>
  );
};

export default ViewOrganization;
